import { Component, HostListener, OnInit, Output } from '@angular/core';
import { UntypedFormBuilder, UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { AdminService } from 'src/app/services/admin.service';
import { CacheService } from 'src/app/services/cache.service';
import { ConstantsService } from 'src/app/services/constants.service';
import { DataService } from 'src/app/services/data.service';
import { GetPaymentService } from 'src/app/services/get-payment.service';
import { UrlConstants } from 'src/app/services/url-constants';
import { UserService } from 'src/app/services/user.service';
import { environment } from 'src/environments/environment';
import * as uuid from 'uuid';
import { Storage } from 'aws-amplify';
import { Auth } from 'aws-amplify';

@Component({
  selector: 'app-edit-profile',
  templateUrl: './edit-profile.component.html',
  styleUrls: ['./edit-profile.component.scss']
})
export class EditProfileComponent implements OnInit {
  public UpdateDetails: UntypedFormGroup;
  profilePicture: any;
  isAdmin: any;
  isLogin: boolean;
  memberId: any;
  isPrime: any;
  subscriptionID: any;
  userEmail: any;
  firstName: any;
  email: any;
  lastName: any;
  userName: any;
  success = null;
  isloading: boolean;
  profilePicturedisplay: string | ArrayBuffer;
  s3ImageDelete: any;
  fileType: any;
  newFile: any;
  profilePicturedisplaytemp: string | ArrayBuffer = '';
  skeltonArray: any = [{}];
  isSkeltonLoad: boolean = true;
  screenHeight: number;
  screenWidth: number;
  windowWidth: string;
  @HostListener('window:resize', ['$event'])
  onResize() {
    this.screenHeight = window.innerHeight;
    this.screenWidth = window.innerWidth;
    if (this.screenWidth <= 658 && this.screenWidth < this.screenHeight) {
      this.windowWidth = `calc(${this.screenHeight}px - 100px )`;
    }
  }
  constructor(
    public constants: ConstantsService,
    private fb: UntypedFormBuilder,
    private cache: CacheService,
    public userService: UserService,
    private get_payment: GetPaymentService,
    private urlConstants: UrlConstants,
    private dataService: DataService,
  ) { }

  ngOnInit(): void {
    this.authcall();
    this.initialiseForm();
    this.onResize();
  }
  async authcall(isEdited = false) {
    await this.cache.getAuthUser()
      .then(async data => {
        let { given_name, picture, userName, family_name, email, login } = data;
        this.firstName = given_name;
        this.lastName = family_name
        this.email = email
        if (isEdited) {
          this.userService.userData = undefined;
        }
        this.profilePicture = picture;
        this.profilePicturedisplay = picture;
        this.isLogin = login;
        this.userName = userName;
        await this.userService.getUser(true).then(res => {
          this.firstName = res.first_name;
          this.lastName = res.last_name
          this.email = res.email;
          if (res.pictureUrl !== undefined) {
            this.profilePicture = res.pictureUrl;
            this.profilePicturedisplay = res.pictureUrl;
          }
          if (res.profile_picture !== undefined) this.s3ImageDelete = res.profile_picture;
          this.userName = res.userName;
          this.isSkeltonLoad = false;
        })
      })
    this.patchValue();
    this.profilePicturedisplaytemp = '';
  }
  patchValue() {
    this.UpdateDetails.patchValue({
      firstName: this.firstName,
      lastName: this.lastName,
    })
  }
  initialiseForm = () => {
    this.UpdateDetails = this.fb.group({
      firstName: new UntypedFormControl(this.firstName, [Validators.required]),
      lastName: new UntypedFormControl(this.lastName, [Validators.required])
    })
  }
  async submit() {
    if (this.UpdateDetails.invalid) return;
    this.isloading = true;
    if (this.fileType !== undefined && this.newFile !== undefined) await this.addToS3(this.newFile, this.fileType);
    let picNameLength = this.profilePicture.split('/');
    const params = [{ param: '{object}', value: 'user' }];
    const bodyObj = {
      userName: this.userName,
      first_name: this.UpdateDetails.value.firstName,
      last_name: this.UpdateDetails.value.lastName,
      profile_picture: this.profilePicture
    };
    if (picNameLength.length > 1) {
      delete bodyObj['profile_picture'];
      this.s3ImageDelete = undefined
    }
    await this.dataService
      .postData(
        this.urlConstants.getUri(this.urlConstants.updateItem, params),
        JSON.stringify(bodyObj)
      )
      .toPromise()
      .then(async (data) => {
        this.updateUser();
        this.success = true;
        this.isloading = false;
        if (this.s3ImageDelete !== undefined) this.removeImageFromS3();
        setTimeout(() => {
          this.success = null;
        }, 5000);
        this.authcall(true);
      })
      .catch((error) => {
        this.success = false;
        this.isloading = false;
        setTimeout(() => {
          this.success = null;
        }, 5000);
      })
  }
  async removeImageFromS3() {
    await Storage.remove('profilePicture/' + this.s3ImageDelete, {
      bucket: `${environment.VIDEO_BUCKET}`
    }).then(async data => {
      // console.log(data);
    })
      .catch(error => {
        // console.log(error);
      })
  }
  async updateUser() {
    const user = await Auth.currentAuthenticatedUser();
    await Auth.updateUserAttributes(user, {
      'given_name': this.UpdateDetails.value.firstName,
      'family_name': this.UpdateDetails.value.lastName
    });
  }
  async selectedFile(event) {
    if (event.target.files && event.target.files[0]) {
      const file = event.target.files[0];
      const reader = new FileReader();
      reader.onload = e => this.profilePicturedisplaytemp = reader.result;
      reader.readAsDataURL(file);
    }
    const uniqueId = uuid.v4();
    this.fileType = event.target.files[0].type
    var file = event.target.files[0]
    var blob = file.slice(0, file.size, this.fileType);
    this.newFile = new File([blob], `${uniqueId}${this.constants.JPG_TXT}`, { type: this.fileType });
    this.profilePicture = this.newFile.name;
  }
  async addToS3(newFile, fileType) {
    await Storage.put(`profilePicture/${newFile.name}`, newFile, {
      bucket: `${environment.VIDEO_BUCKET}`,
      contentType: `${fileType}`
    }).then(async data => {
      // console.log(data);
    })
      .catch(error => {
        // console.log(error);
      })
  }
}
